"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cryptos = [
    "BTC",
    "ETH",
    "BAT",
    "USDT",
    "ALGO",
    "TRX",
    "OKB",
    "BCH",
    "DAI",
    "TON",
    "BNB",
    "1INCH",
    "NEAR",
    "SOL",
    "DOT",
    "ADA",
    "KSM",
    "MATIC",
    "ATOM",
    "AVAX",
    "XLM",
    "XRP",
    "LTC",
    "SAND",
    "DYDX",
    "MANA",
    "USDC",
    "CRV",
    "FTM",
    "DOGE",
    "XTZ",
    "WEMIX",
    "TIA",
    "ARB",
];
exports.default = cryptos;
//# sourceMappingURL=cryptos.js.map